const ProgressBar = ({ progress, showPercentage = true }) => (
  <div className="space-y-2">
    <div className="w-full bg-gray-100 rounded-full h-2.5 overflow-hidden">
      <div
        className="bg-indigo-600 h-2.5 rounded-full transition-all duration-300 ease-in-out"
        style={{ width: `${progress}%` }}
      />
    </div>
    {showPercentage && (
      <p className="text-sm text-gray-600 text-right">{Math.round(progress)}% complete</p>
    )}
  </div>
);

export default ProgressBar;
